import { FormGroup, InputGroup } from "@blueprintjs/core";
import React from "react";

interface Props {
  helperText?: string;
  disabled?: boolean;
  label?: string;
  id: string;
  labelInfo?: string;
  placeHolder?: string;
  value: string;
  type?: string;
  onChange: (str: string) => void;
}

export default function Inputbox(props: Props) {
  return (
    <div>
      <FormGroup
        helperText={props.helperText}
        label={props.label}
        labelInfo={props.labelInfo}
        labelFor={props.id}
      >
        <InputGroup
          id={props.id}
          placeholder={props.placeHolder}
          onChange={(e) => props.onChange(e.target.value)}
          value={props.value}
          disabled={props.disabled}
          type={props.type}
        />
      </FormGroup>
    </div>
  );
}
